import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectMetadataComponent } from './components/selectmetadate/selectmetadata.component';
import { TreeclassifierComponent } from './components/treeclassifier/treeclassifier.component';
import { TemplatemetadataComponent } from './components/metadatalist/metadatalist.component';
import { FormsModule } from '@angular/forms';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { GridModule } from '@progress/kendo-angular-grid';
import { MetadataService } from './metadata.service';
import { FarrisDialogModule } from '@farris/ui-dialog';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MetadatapackageselectComponent } from './components/metadatapackageselect/metadatapackageselect.component';
import { MetadatapackagelistComponent } from './components/metadatapackagelist/metadatapackagelist.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { MetadatalistdetailsComponent } from './components/metadatalist/metadatalistdetails/metadatalistdetails.component';
import { LoadingModule } from '@farris/ui-loading';
import { OnceClickDirective } from './components/selectmetadate/onclick.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TreeViewModule,
    GridModule,
    LayoutModule,
    FarrisDialogModule,
    DropDownsModule,
    LoadingModule.forRoot()
  ],
  exports: [
    SelectMetadataComponent
  ],
  providers: [MetadataService], // 服务提供者
  // tslint:disable-next-line:max-line-length
  declarations: [
    SelectMetadataComponent,
    TreeclassifierComponent,
    TemplatemetadataComponent,
    MetadatapackageselectComponent,
    MetadatapackagelistComponent,
    MetadatalistdetailsComponent,
    OnceClickDirective
  ],
  entryComponents: [SelectMetadataComponent, MetadatapackageselectComponent]
})
export class MetadataSelectModule {
  constructor() {
  }
}
